module.exports = __webpack_public_path__ + "img/photo-0132.ae9ff1a4.jpg";